module.exports = __webpack_public_path__ + "img/bgMob.6742b514.webp";